import React from "react"
import Header from "../components/home-page-header/index"
import Footer from "../components/footer/index"
import Fantacy from "../components/fantacy-card/index"
import Whowe from "../components/who-we-are/index"
import Services from "../components/services/index"
import Agency from "../components/agency-task/index"
import Headernav from "../components/header/index"
import {Helmet} from "react-helmet"
export default () => {
    return (
        <>
        <Helmet>
            <meta charSet="utf-8"/>
            <title>Desingers Hub</title>
            <meta property="og:locale" content="en_US"/>
            <meta property="og:type" content="website"/>
            <link rel="alternate" href="https://www.desingershub.io" hreflang="en-us"/>
            <link rel="canonical" href="https://www.desingershub.io/"/>
            <meta name="description"
                  content="We are working with the modern technologies to build web applications and hybrid applications in both corporate and startup environments with broad and diverse experience that balance code, cost, user experience and performance."/>
            <meta name="keywords"
                  content="Development, Mobile Development, UX/UI, NodeJS, javascript, web design, web dev, desingershub, geeks, hub, desingershub.io, desingershub.org"/>
            <meta name="author" content="DesingersHub"/>
            <meta property="og:title" content="DesingersHub"/>
            <meta property="og:description"
                  content="We are working with the modern technologies to build web applications and hybrid applications in both corporate and startup environments with broad and diverse experience that balance code, cost, user experience and performance."/>
            <meta property="og:url" content="https://www.desingershub.io/"/>
            <meta property="og:site_name" content="DesingersHub"/>
            <meta property="og:image" content={require("../images/desingershub-dark.png")}/>
            <meta property="og:image:width" content="420"/>
            <meta property="og:image:height" content="420"/>
            <meta name="twitter:card" content="summary"/>
            <meta name="twitter:description"
                  content="We are working with the modern technologies to build web applications and hybrid applications in both corporate and startup environments with broad and diverse experience that balance code, cost, user experience and performance."/>
            <meta name="twitter:title" content="DesingersHub"/>
            <meta name="twitter:site" content="@designershub_i"/>
            <meta name="twitter:image" content={require("../images/desingershub-dark.png")}/>
            <meta name="twitter:creator" content="@designershub_i"/>
            <meta property="DC.date.issued" content="2017-04-04T16:12:12-05:00"/>
            <meta name="google-site-verification" content="JSDvTu058M1UuhdASFVpudUNAhW8rLEJGaIVj4VmyuE"/>
            <script type="text/javascript" async>
                {typeof document !== "undefined" && document.body.clientWidth > 991 && `function googleTranslateElementInit() {
            new google.translate.TranslateElement({pageLanguage: 'en', layout: google.translate.TranslateElement.InlineLayout.SIMPLE}, 'google_translate_element');
        }`}
            </script>
            <script type="text/javascript">
                {typeof document !== "undefined" && document.body.clientWidth < 992 && `function googleTranslateElementInit() {
            new google.translate.TranslateElement({pageLanguage: 'en', layout: google.translate.TranslateElement.InlineLayout.VERTICAL}, 'google_translate_element1');
        }`}
            </script>
            <script type="text/javascript"
                    src="//translate.google.com/translate_a/element.js?cb=googleTranslateElementInit"></script>
        </Helmet>
        <Headernav />
        <Header />
        <Fantacy />
        <Whowe />
        <Services />
        <Agency />
        <Footer />
        </>
    )
}
